import script from "./SubscriptionCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionCompany.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionCompany.vue?vue&type=style&index=0&id=2c31bae6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c31bae6"]])

export default __exports__